export class Designationmaster {
    ID: number;
    PARENT_ID: number = 0;
    ORG_ID: number
    CLIENT_ID: number;
    NAME: string;
    SHORT_CODE: string;
    STATUS: boolean = true;
    SEQUENCE_NO: number;
}